export default __webpack_public_path__ + "static/media/gallery_03.eec2562d.jpg";